import Swal from "sweetalert2";

const subscription = () =>{
    var date = new Date(),
    y = date.getFullYear(),
    m = (date.getMonth() + 1).toString().padStart(2, '0'),
    d = date.getDate().toString().padStart(2, '0'),
    lastYear = date.getFullYear() - 1

    var firstDay = m + "/" + d + "/"+ lastYear ;
    var todayDate = m + "/" + d + "/" + y;

    let start_date = y-1 + "-" + m + "-" + d;
    let end_date = y + "-" + m + "-" + d;
    
    if(m == '02' && d > 28){
        firstDay = m + "/" + 28 + "/"+ lastYear ;
        start_date = y-1 + "-" + m + "-" + 28;
    }
    
    let orderTable = "";
    let orderHistoryTable = "";
    let publisherId = "";
    const subscriptionDt = () => {
        orderTable = $("#subscription_dt").DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            //ordering: true,
            searching: true,
            order: [[5, "desc"]],
            // "sProcessing": "Please wait...",
            language: {
                processing:
                    '<i class="myspinner fa fa-spinner fa-spin" style="font-size:24px;color:rgb(75, 183, 245);"></i>',
            },
            // "pagingType": "full_numbers",
            pageLength: 25,
            ajax: {
                url: "/subscription/listing",
                type: "POST",
                datatype: "json",
                data: function (data) {
                    data.startDate = start_date;
                    data.endDate = end_date;
                    data.publisherId = publisherId;
                },
            },
            columns: [
                { data: "user_id", name: "user.name" , orderable: false},
                { data: "publisher_id", name: "user.name" , orderable: false },
                { data: "business_name", name: "subscriptions.business_id" },
                { data: "status", name: "subscriptions.subscription_status" },
                { data: "amount", name: "subscriptions.subscription_amount"},
                { data: "order_date", name: "subscriptions.created_at" },
                { data: "history", name: "subscriptions.history" },
            ],
            // footerCallback: function (row, data, start, end, display) {
            //     var api = this.api();
            //     var total = 0;
            //     var pageTotal;
            //     // Remove the formatting to get integer data for summation
            //     var intVal = function (i) {
            //         return typeof i === 'string' ? i.replace(/[\$,]/g, '') * 1 : typeof i === 'number' ? i : 0;
            //     };

            //     // Total over all pages
            //     total = api
            //         .column(4)
            //         .data()
            //         .reduce(function (a, b) {
            //             return intVal(a) + intVal(b);
            //         }, 0);

            //     // Total over this page
            //     pageTotal = api
            //         .column(4, { page: 'current' })
            //         .data()
            //         .reduce(function (a, b) {
            //             return intVal(a) + intVal(b);
            //         }, 0);

            //     // Update footer
            //    // $(api.column(3).footer()).html('$' + pageTotal + ' ( $' + total + ' total)');
            //    $(api.column(4).footer()).html('Total : '+total);
            // },
        });
    }

    if ($("#subscription_dt").length > 0) {
        $("#publisherId").select2();

        subscriptionDt();
        $(function () {
            $('input[name="daterange"]').daterangepicker(
                {
                    // autoApply: true,
                    startDate: firstDay,
                    endDate: todayDate,
                    locale: {
                        cancelLabel: 'Clear'
                    }
                },
                function (start, end, label) {
                    start_date = start.format("YYYY-MM-DD");
                    end_date = end.format("YYYY-MM-DD");
                    orderTable.draw();
                }
            );
        });

        $("#publisherId").on("select2:select", function (e) {
            publisherId = $(this).val();
            orderTable.draw();
        });

        $('input[name="daterange"]').on('cancel.daterangepicker', function(ev, picker) {
            $(this).val('')
            picker.setStartDate({})
            picker.setEndDate({})
            start_date = '';
            end_date = '';
            orderTable.draw();
        });
    }


    const subscriptionMailHistoryDt = () => {
        orderHistoryTable = $("#subscriptionMailHistoryDt").DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            searching: true,
            order: [[0, "desc"]],
            language: {
                processing:
                    '<i class="myspinner fa fa-spinner fa-spin" style="font-size:24px;color:rgb(75, 183, 245);"></i>',
            },
            pageLength: 25,
            ajax: {
                url: "/subscription/mail-history",
                type: "POST",
                datatype: "json",
                data: function (data) {
                    data.startDate = start_date;
                    data.endDate = end_date;
                    data.invoice_no = $('#subscriptionMailHistoryDt').data('invoice_no')
                },
            },
            columns: [
                { data: "date", name: "date" },
                { data: "status", name: "status" },
                { data: "reason", name: "reason" },
                // { data: "business_name", name: "business_name" },
                // { data: "client_email", name: "client_email" },
                // { data: "recepient_email", name: "recepient_email"},
            ],
        });
    };

    if ($("#subscriptionMailHistoryDt").length > 0) {
        $("#publisherId").select2();

        subscriptionMailHistoryDt();
        $(function () {
            $('input[name="daterange"]').daterangepicker(
                {
                    // autoApply: true,
                    startDate: firstDay,
                    endDate: todayDate,
                    locale: {
                        cancelLabel: 'Clear'
                    }
                },
                function (start, end, label) {
                    start_date = start.format("YYYY-MM-DD");
                    end_date = end.format("YYYY-MM-DD");
                    orderHistoryTable.draw();
                }
            );
        });

        $("#publisherId").on("select2:select", function (e) {
            publisherId = $(this).val();
            orderHistoryTable.draw();
        });

        $('input[name="daterange"]').on('cancel.daterangepicker', function(ev, picker) {
            $(this).val('')
            picker.setStartDate({})
            picker.setEndDate({})
            start_date = '';
            end_date = '';
            orderHistoryTable.draw();
        });
    }

    const subscriptionPaymentDt = () => {
        orderHistoryTable = $("#subscriptionPaymentDt").DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            searching: true,
            order: [[2, "desc"]],
            language: {
                processing:
                    '<i class="myspinner fa fa-spinner fa-spin" style="font-size:24px;color:rgb(75, 183, 245);"></i>',
            },
            pageLength: 25,
            ajax: {
                url: "/subscription/payment-log",
                type: "POST",
                datatype: "json",
                data: function (data) {
                    data.startDate = start_date;
                    data.endDate = end_date;
                    data.invoice_no = $('#subscriptionPaymentDt').data('invoice_no')
                },
            },
            columns: [
                { data: "invoice_number", name: "invoice_number" },
                { data: "status", name: "status" },
                { data: "paid_date", name: "paid_date" },
                { data: "amount", name: "amount" },
                { data: "net_transaction_id", name: "net_transaction_id" },
                { data: "invoice", name: "invoice" }
            ],
        });
    };
    subscriptionPaymentDt();

    $(document).on('click','.cancel-subscription',function(e){
        e.preventDefault();
        Swal.fire({
            icon: 'error',
            title: 'Do you want to cancel this subscription?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
        }).then((result) => {
            if (result.isConfirmed) {
               window.location.href = $(this).data('href');
            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        });
    });

    $("#subClientEmail").editable({
        type: "text",
        pk: 1,
        name: "client_mail",
        title: "Client Mail",
        mode: "inline",
        inputclass: "form-control",
        validate: function (value) {
            if ($.trim(value) == "") {
                return "This field is required";
            }
        },
        success: function (response, newValue) {
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/edit/sub-email",
                type: "get",
                data: { "mail" : newValue , "id": $('#uuid').val(), "action": "client" },
                success: function (res) {
                    Swal.fire("Changed!", res.message, "success");
                },
                error: function (error) {
                    Swal.fire("Error!", error.responseJSON.message, "error");
                },
            })
        },
    });

    $("#subRecepientEmail").editable({
        type: "text",
        pk: 1,
        name: "recepient_mail",
        title: "Recepient Mail",
        mode: "inline",
        inputclass: "form-control",
        validate: function (value) {
            if ($.trim(value) == "") {
                return "This field is required";
            }
        },
        success: function (response, newValue) {
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/edit/sub-email",
                type: "get",
                data: { "mail" : newValue ,"id": $('#uuid').val(), "action": "recepient" },
                success: function (res) {
                    Swal.fire("Changed!", res.message, "success");
                },
                error: function (error) {
                    Swal.fire("Error!", error.responseJSON.message, "error");
                },
            })
        },
    });

    $(document).on('click', '#export_subscription', function (event) {
        var query = {
            startDate: start_date,
            endDate:end_date,
            publisherId :publisherId
        }
        var url = baseUrl + "/export-subscription?" + $.param(query);
        window.location = url;

    });

    $(document).on('submit','#cardUpdateForm',function(e){
        e.preventDefault();
        $(".spinner-border").show();
        $("#overlay").show();
        let formData = new FormData($(this)[0])
        $('#cardModal').modal('hide');
        $.ajax({
            url:baseUrl+'/update-card',
            type:'post',
            data:formData,
            processData: false,
            contentType: false,
            success:function(res){
                $(".spinner-border").hide();
                $("#overlay").hide();
                Swal.fire('Success',res.message,'success',2000);

            },
            error : function(res){
                $(".spinner-border").hide();
                $("#overlay").hide();
                Swal.fire('Error',res.responseJSON.message,'error',2000);
                setTimeout(function(){
                    window.location.reload();
                },2000);
            }
        })
    })

    $("#cardModal").on('hide.bs.modal', function(){
        document.getElementById("cardUpdateForm").reset();
    });


    $(document).on('submit','#exportSubscriptionReport',function(){
        $('#exportSubscriptionReportModal').modal('hide');
    });
    if($('#landingPagelocationFilter').length > 0){
        $(function(){
            var input = document.getElementById("landingPagelocationFilter");
            var autocomplete = new google.maps.places.Autocomplete(input);
        })
    }

    var today = new Date();
    var time = today.getHours() + "." + today.getMinutes();

    $('#photoTabButton').click(function(e){
        e.preventDefault();
        $('#mytabs a[href="#menu1"]').tab('show');
    });
}
export default subscription;